import GeneralNotesModule from '@/modules/general-notes/GeneralNotesModule';

export default GeneralNotesModule;
